import {poiCategoriesEndpoint} from '../endpoints/endpoints';
import { singleRequestServiceFactory } from './request/singleRequestServiceFactory';

export const poiCategoriesRest = {
    poiCategories: singleRequestServiceFactory(poiCategoriesEndpoint)
};
